module.exports = __webpack_public_path__ + "static/media/granny smith.61afacd5.jpg";